import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { ROUTES } from '@/constants/routes';
import { hasRequiredCampaignParams } from '@/utils/campaignAccess';
import {
  hasPaywallWebViewBridge,
  hasPaywallWebViewUserAgent,
} from '@/utils/webViewAccess';

interface WebOnlyCampaignRouteGuardProps {
  children: ReactNode;
}

function isEmbeddedWindow(): boolean {
  return typeof window !== 'undefined' && window.parent !== window;
}

export function WebOnlyCampaignRouteGuard({ children }: WebOnlyCampaignRouteGuardProps) {
  const location = useLocation();
  const isWebView = hasPaywallWebViewUserAgent()
    || hasPaywallWebViewBridge()
    || isEmbeddedWindow();

  if (isWebView || !hasRequiredCampaignParams(location.search)) {
    return <Navigate to={ROUTES.HOME} replace />;
  }

  return <>{children}</>;
}
